import React, { createContext, useContext, ReactNode } from 'react';

interface PlayerVisibilityContextType {
  /**
   * True while the fixed-position PersistentAudioPlayer is docked at the
   * bottom of the viewport. It sits above the page footer at every
   * breakpoint, so anything that's normally reachable only through the
   * footer (Terms, Privacy, theme toggle, etc.) needs another way in.
   */
  isPersistentPlayerOpen: boolean;
}

const PlayerVisibilityContext = createContext<PlayerVisibilityContextType | undefined>(undefined);

export const usePlayerVisibility = () => {
  const context = useContext(PlayerVisibilityContext);
  if (context === undefined) {
    throw new Error('usePlayerVisibility must be used within a PlayerVisibilityProvider');
  }
  return context;
};

interface PlayerVisibilityProviderProps {
  isPersistentPlayerOpen: boolean;
  children: ReactNode;
}

export const PlayerVisibilityProvider: React.FC<PlayerVisibilityProviderProps> = ({
  isPersistentPlayerOpen,
  children,
}) => {
  return (
    <PlayerVisibilityContext.Provider value={{ isPersistentPlayerOpen }}>
      {children}
    </PlayerVisibilityContext.Provider>
  );
};
